<template>
  <div>
    <ShowFull :path="$route.path" />
  </div>
</template>
